// Module
var code = "<!-- ko template: { nodes: $componentTemplateNodes } -->\n<!-- /ko -->";
// Exports
module.exports = code;